// extracted by mini-css-extract-plugin
export default {"wechatCode":"WechatScanForm_wechatCode__Kk8YI"};